import React, { useEffect } from 'react';
import './HomePage.css'; // 引入新的CSS文件
import './guanggao.css'; // 引入广告的CSS文件

const ServicePage = () => {
  useEffect(() => {
    // 组件挂载时添加类名以禁止滚动
    document.body.classList.add('no-scroll');
    return () => {
      // 组件卸载时移除类名以恢复滚动
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <main className="snap-container">
      <section className="snap-section">
        <div className="flex flex-col h-screen">
          {/* 上半部分，占屏幕高度的40%，显示上线提示 */}
          <div className="h-2/5 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center">
            <div className="text-center text-white">
              <h1 className="text-4xl font-bold mb-4">正在上线中</h1>
              <p className="text-xl">我们正在为您准备更好的服务</p>
            </div>
          </div>
          {/* 下半部分，占屏幕高度的60%，显示加载动画和提示 */}
          <div className="h-3/5 bg-gray-900 flex flex-col items-center justify-center">
            {/* 加载动画 */}
            <div className="w-24 h-24 border-4 border-t-blue-500 border-r-purple-500 border-b-green-500 border-l-yellow-500 rounded-full animate-spin mb-8"></div>
            {/* 提示文字 */}
            <div className="text-center text-white">
              <p className="text-2xl font-bold mb-4">敬请稍候</p>
              <p className="text-gray-300 max-w-md">我们正在进行系统升级和优化，将为您带来更好的使用体验。</p>
              <p className="text-gray-400 mt-4">预计很快就能与您见面</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ServicePage;